class AppColors {

    /**
     * The default page background color
     * @type {string}
     */
    static PageBackgroundColor = '#009846';

    /**
     * White background color for pages
     * @type {string}
     */
    static PageWhiteBgColor = '#ffffff';

}

export default AppColors;


// WEBPACK FOOTER //
// ./src/common/Colors.js